var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{class:_vm.$style.header},[_c('div',{class:_vm.$style.wrapper},[_vm._v("\n    © GO2 Partners ©"+_vm._s(new Date().getFullYear())+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }